// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { DatePicker } from '../../../components/ant/DatePicker';

import { formatDateTimeToISOString } from '../../../lib/helpers';
import { serviceTypeEnum } from '../../../lib/enum';

import {
  Filter,
  FilterContainer,
  FilterItem,
  Selects,
  FilterButtonsContainer } from
'../../../components';

import Field from '../../../components/card/Field';
import Input from '../../../components/ui/CustomInput';

const { ContractorSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "Filter__SpoilerContent", componentId: "sc-gg5cl1-0" })(["padding:16px;"]);















export const DriverInspectionFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <Input
              placeholder="Номер акта"
              size="small"
              onChange={({ target: { value } }) =>
              changeValue('actNumber', !!value ? value : undefined)
              }
              value={values.actNumber} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <ContractorSelect
              size="small"
              onChange={(value) => changeValue('contractorId', value)}
              value={values.contractorId}
              filter={{
                services: serviceTypeEnum.driversCheck
              }} />

              </Field>
            </FilterItem>

            <FilterItem>
              <Field mBottomNone>
                <DatePicker
              size="small"
              format="DD.MM.YYYY"
              value={values.actDate && moment.utc(values.actDate)}
              placeholder="Дата окончания"
              onChange={(value, dateString) =>
              changeValue(
                'actDate',
                formatDateTimeToISOString(value, dateString)
              )
              } />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;


export default DriverInspectionFilter;
